import z from "zod";
import { SUPPORTED_CONNECTOR_PROTOCOL_VERSION } from "./protocol.js";
import { ConnectorTaskRequestSchema, ConnectorTaskResultSchema, } from "./envelope.schema.js";
import { ConnectorTransportCredentialAckSchema, ConnectorTransportCredentialSchema, } from "./credential.schema.js";
import { ConnectorTransportOAuthRequestSchema, ConnectorTransportOAuthResponseSchema, } from "./oauth.schema.js";
const transportBaseSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
});
export const ConnectorTransportChallengeSchema = transportBaseSchema.extend({
    kind: z.literal("challenge"),
    nonce: z.string().min(1),
    issuedAt: z.string().datetime(),
});
export const ConnectorTransportReadySchema = transportBaseSchema.extend({
    kind: z.literal("ready"),
    connectorId: z.string().uuid(),
    heartbeatIntervalMs: z.number().int().positive(),
});
export const ConnectorTransportTaskSchema = transportBaseSchema.extend({
    kind: z.literal("task"),
    taskId: z.string().uuid(),
    request: ConnectorTaskRequestSchema,
});
export const ConnectorTransportErrorSchema = transportBaseSchema.extend({
    kind: z.literal("error"),
    code: z.string().min(1),
    message: z.string().min(1),
});
export const ConnectorTransportAuthSchema = transportBaseSchema.extend({
    kind: z.literal("auth"),
    connectorId: z.string().uuid(),
    connectorVersion: z.string().min(1),
    signature: z.string().min(1),
});
export const ConnectorTransportHeartbeatSchema = transportBaseSchema.extend({
    kind: z.literal("heartbeat"),
    connectorVersion: z.string().min(1).optional(),
});
export const ConnectorTransportResultSchema = transportBaseSchema.extend({
    kind: z.literal("result"),
    taskId: z.string().uuid(),
    result: ConnectorTaskResultSchema,
});
export const ConnectorTransportCredentialFrameSchema = ConnectorTransportCredentialSchema;
export const ConnectorTransportCredentialAckFrameSchema = ConnectorTransportCredentialAckSchema;
export const ConnectorTransportOAuthRequestFrameSchema = ConnectorTransportOAuthRequestSchema;
export const ConnectorTransportOAuthResponseFrameSchema = ConnectorTransportOAuthResponseSchema;
export const ConnectorTransportMessageSchema = z.discriminatedUnion("kind", [
    ConnectorTransportChallengeSchema,
    ConnectorTransportReadySchema,
    ConnectorTransportTaskSchema,
    ConnectorTransportErrorSchema,
    ConnectorTransportAuthSchema,
    ConnectorTransportHeartbeatSchema,
    ConnectorTransportResultSchema,
    ConnectorTransportCredentialFrameSchema,
    ConnectorTransportCredentialAckFrameSchema,
    ConnectorTransportOAuthRequestFrameSchema,
    ConnectorTransportOAuthResponseFrameSchema,
]);
/** Canonical bytes signed during connector transport authentication. */
export function buildConnectorAuthPayload(connectorId, nonce) {
    return `${connectorId}:${nonce}`;
}
//# sourceMappingURL=transport.schema.js.map